import { useTranslation } from 'react-i18next'
import { BotIcon } from 'lucide-react'
import { FDEMessageList } from './FDEMessageList'
import { FDEMessageInput } from './FDEMessageInput'
import type { FDEMessage } from '@/types/fde'

interface FDEChatPaneProps {
  messages: FDEMessage[]
  processing: boolean
  currentActivity: string | null
  isSendingMessage: boolean
  onSendMessage: (content: string) => Promise<void>
}

export function FDEChatPane({
  messages,
  processing,
  currentActivity,
  isSendingMessage,
  onSendMessage,
}: FDEChatPaneProps) {
  const { t } = useTranslation('fde')

  if (messages.length === 0 && !processing) {
    return (
      <div className="flex flex-1 flex-col min-w-0 h-full min-h-0">
        <div className="flex flex-1 items-center justify-center">
          <div className="text-center">
            <BotIcon className="mx-auto h-12 w-12 text-muted-foreground/30 mb-4" />
            <h3 className="text-lg font-medium mb-1">{t('chat.emptyState')}</h3>
            <p className="text-sm text-muted-foreground max-w-sm">{t('chat.emptyStateDescription')}</p>
          </div>
        </div>
        <FDEMessageInput
          onSendMessage={onSendMessage}
          disabled={false}
          isSending={isSendingMessage}
          isProcessing={processing}
        />
      </div>
    )
  }

  return (
    <div className="flex flex-1 flex-col min-w-0 h-full min-h-0">
      <FDEMessageList
        messages={messages}
        processing={processing}
        currentActivity={currentActivity}
      />
      <FDEMessageInput
        onSendMessage={onSendMessage}
        disabled={false}
        isSending={isSendingMessage}
        isProcessing={processing}
      />
    </div>
  )
}
